import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class TranslationLoadedService {
  private _defaultLanguage = new BehaviorSubject<string>("es");
  defaultLanguage$ = this._defaultLanguage.asObservable();
  private translationLoaded: Subject<void> = new Subject<void>();
  private _isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this._isLoading.asObservable();

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.userData$.subscribe((res: any) => {
      if (res.language) {
        const lang = res.language;
        this._defaultLanguage.next(lang);
      }
    });
    console.log("lang cambiado",  this._defaultLanguage);
  }

  loaded$(): Subject<void> {
    return this.translationLoaded;
  }

  startLoading() {
    this._isLoading.next(false);
  }

  finishLoading() {
    this._isLoading.next(true);
  }


  changeLanguage(lang: string) {
    this._defaultLanguage.next(lang);
    return console.log("lenguaje cambiado con exito ", lang);
  }

  updateLanguaje(id, auth_key, language) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("language", language);
    return this.http.post(environment.urlPerfil + "?opcion=9", formData);
  }
}
